import React from 'react';
import './index.scss';

export class WrongPage extends React.Component {

  render() {
    return (
      <div className="wrong_page" style={{height:document.documentElement.clientHeight}}>
        <img src={require('../../assets/noPage.png')} alt=""/>
        <span>找不到该页面,请输入正确的地址重试！</span>
      </div>
      //{' '}
    );
  }
}
